import React from "react";
import _ from "lodash";

import Board from "views/components/Board.jsx";
import {
  useFirestoreConnect,
  useFirestore,
  isLoaded,
  isEmpty,
} from "react-redux-firebase";
import { useSelector } from "react-redux";
import { useTable } from "react-table";
import { NavLink } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";

// reactstrap components
import {
  Alert,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Badge,
  Jumbotron,
} from "reactstrap";
import { useRef, useEffect, useState } from "react";
import moment from "moment";

import GroupCategoryForm from "views/forms/GroupCategoryForm";
import { roles } from "variables/constants";
import { getCustomClaimsFromLocalStorage } from "helpers/localStorage";

import { activeStatusString } from "variables/constants";
import { useTranslation } from "react-i18next";

export default function GroupCategories() {
  const { t } = useTranslation();
  const firestore = useFirestore();
  const profile = useSelector((state) => state.firebase.profile);

  let channel, role;

  if (isLoaded(profile) && !isEmpty(profile)) {
    channel = profile.channel;
    role = profile.role;
  } else {
    const customClaims = getCustomClaimsFromLocalStorage();
    const { channelId } = customClaims;
    role = customClaims.role;
    channel = { id: channelId };
  }

  let whereOptions;
  if (role === roles.channelAdmin && channel.id) {
    whereOptions = [["channel.id", "==", channel.id]];
  }
  console.log("whereOptions: ", whereOptions);
  useFirestoreConnect([
    { collection: "channels" },
    {
      collection: "groupCategories",
      where: whereOptions,
    },
  ]);

  const channels = useSelector((state) => state.firestore.ordered.channels);
  const items = useSelector((state) => state.firestore.ordered.groupCategories);
  const boardEl = useRef(null);
  const [alert, setAlert] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [toastMessage, setToastMessage] = useState(null);

  const data =
    items &&
    items.map((item) => ({
      ...item,
      actions: (
        // we've added some custom button actions
        <div className="actions-left">
          <Button
            onClick={() => {
              console.log("clicked");
              boardEl.current.edit(item);
            }}
            color="warning"
            size="sm"
            className="btn-icon btn-link edit"
          >
            <i className="fa fa-edit" style={{ fontSize: "1.5em" }} />
          </Button>{" "}
          {/* use this button to remove the data row */}
          <Button
            onClick={() => {
              console.log("clicked");
              warningWithConfirmAndCancelMessage(item);
            }}
            color="danger"
            size="sm"
            className="btn-icon btn-link remove"
          >
            <i className="fa fa-times" style={{ fontSize: "1.5em" }} />
          </Button>{" "}
        </div>
      ),
    }));
  // console.log('data', data);

  const warningWithConfirmAndCancelMessage = (item) =>
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={
          <div>
            삭제하면 복구할 수 없습니다.
            <br />
            계속 진행하시겠습니까?
          </div>
        }
        onConfirm={() => {
          firestore.doc(`groupCategories/${item.id}`).delete();
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="확인"
        cancelBtnText="취소"
        showCancel
      >
        지우면 완전히 삭제됩니다. 지우시겠습니까?
      </ReactBSAlert>
    );

  return (
    <div className="content">
      <Alert
        isOpen={Boolean(toastMessage)}
        toggle={() => setToastMessage(null)}
        color="info"
      >
        {toastMessage}
      </Alert>
      {alert}
      <Breadcrumb className="sticky-top">
        <BreadcrumbItem>
          <a href="/">Home</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>대리점 목록</BreadcrumbItem>
      </Breadcrumb>
      <Jumbotron>
        <h1 className="display-5">
          <strong>대리점 목록</strong>
        </h1>
        <p className="lead">
          이곳에서 {channels?.length || 0}개의 총판 하위 <br />{" "}
          <strong>{items?.length || 0}개 대리점의 정보</strong>를 확인 및 수정할
          수 있습니다.
        </p>
        <hr className="my-2" />
        <p>
          <strong>⚠️NOTE</strong> 대리점에서의 상태(정상/만료/차단) 변경은
          대리점 관리자 계정의 상태를 변경하게 됩니다.
        </p>
      </Jumbotron>
      <Board
        modalTitle="대리점 입력폼"
        data={data}
        ref={boardEl}
        columns={[
          {
            Header: "대리점명",
            accessor: "title",
            filterMethod: (filter, row) => {
              console.log("filter = ", filter);
              const title = row[filter.id];
              console.log("row title = ", title);
              return title && title.indexOf(filter.value) != -1;
            },
          },
          {
            width: 140,
            id: "status",
            Header: "상태",
            accessor: (d) => {
              let _color = "primary";
              if (d.status === 2) {
                _color = "warning";
              }
              if (d.status === 3) {
                _color = "danger";
              }
              return (
                <Badge color={_color}>
                  {activeStatusString[d.status - 1 || 0]}
                </Badge>
              );
            },
            filterMethod: (filter, row) => {
              if (filter.value === "all") {
                return true;
              }
              if (
                activeStatusString[filter?.value] ===
                row[filter.id].props.children
              ) {
                return true;
              }
              return false;
            },
            Filter: ({ filter, onChange }) => (
              <select
                onChange={(event) => {
                  console.log("event.target.value = ", event.target.value);
                  return onChange(event.target.value);
                }}
                style={{ width: "100%" }}
                value={filter ? filter.value : "all"}
              >
                <option value="all">전체</option>
                {activeStatusString.map((status, idx) => (
                  <option key={idx} value={idx}>
                    {t(status)}
                  </option>
                ))}
              </select>
            ),
          },
          {
            id: "channel",
            Header: "총판명",
            accessor: "channel.title",
            filterMethod: (filter, row) => {
              if (filter.value === "all") {
                return true;
              }
              if (filter?.value === row[filter.id]) {
                return true;
              }
              return false;
            },
            Filter: ({ filter, onChange }) => (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : "all"}
              >
                <option value="all">총판 전체</option>
                {channels?.map((channel) => (
                  <option key={channel.id} value={channel.title}>
                    {channel.title}
                  </option>
                ))}
              </select>
            ),
          },
          {
            Header: "설명",
            accessor: "description",
            filterMethod: (filter, row) => {
              console.log("filter = ", filter);
              const title = row[filter.id];
              console.log("row title = ", title);
              return title && title.indexOf(filter.value) != -1;
            },
          },
          {
            id: "createdAt",
            Header: "등록일시",
            accessor: (d) =>
              d.createdAt
                ? moment(d.createdAt.toDate()).format("YYYY-MM-DD HH:mm")
                : "",
          },
          {
            Header: "명령",
            accessor: "actions",
            sortable: false,
            filterable: false,
          },
        ]}
      >
        <GroupCategoryForm />
      </Board>
    </div>
  );
}
